import { render, staticRenderFns } from "./statement-query.vue?vue&type=template&id=2dd7ea85&scoped=true&"
import script from "./statement-query.vue?vue&type=script&lang=ts&"
export * from "./statement-query.vue?vue&type=script&lang=ts&"
import style0 from "./statement-query.vue?vue&type=style&index=0&id=2dd7ea85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7ea85",
  null
  
)

export default component.exports